// Define the UseCase type for better type checking
export interface UseCase {
  id: number;
  code: string;
  payment_gateway: string[]; // Using an array to allow multiple values
  type: string;
}

export const useCases: UseCase[] = [
  // FOR ME
  {
    id: 1,
    code: 'all-you-can-read',
    payment_gateway: ['gopay', 'gopay_recurrent'],
    type: 'for-me',
  },
  {
    id: 2,
    code: 'all-you-can-read',
    payment_gateway: ['bank_transfer'],
    type: 'for-me',
  },
  {
    id: 3,
    code: 'classic',
    payment_gateway: ['gopay', 'gopay_recurrent'],
    type: 'for-me',
  },
  {
    id: 4,
    code: 'classic',
    payment_gateway: ['bank_transfer'],
    type: 'for-me',
  },
  {
    id: 5,
    code: 'premium',
    payment_gateway: ['gopay', 'gopay_recurrent'],
    type: 'for-me',
  },
  {
    id: 6,
    code: 'premium',
    payment_gateway: ['bank_transfer'],
    type: 'for-me',
  },
  // GIFTS
  {
    id: 7,
    code: 'all-you-can-read',
    payment_gateway: ['gopay'],
    type: 'gift',
  },
  {
    id: 8,
    code: 'all-you-can-read',
    payment_gateway: ['bank_transfer'],
    type: 'gift',
  },
  {
    id: 9,
    code: 'classic',
    payment_gateway: ['gopay'],
    type: 'gift',
  },
  {
    id: 10,
    code: 'classic',
    payment_gateway: ['bank_transfer'],
    type: 'gift',
  },
  {
    id: 11,
    code: 'premium roční',
    payment_gateway: ['gopay'],
    type: 'gift',
  },
  {
    id: 12,
    code: 'premium roční',
    payment_gateway: ['bank_transfer'],
    type: 'gift',
  },
  // BUSINESS
  {
    id: 13,
    code: 'family-premium-print-yearly-dynamic-count',
    payment_gateway: ['gopay', 'gopay_recurrent'],
    type: 'business',
  },
  {
    id: 14,
    code: 'family-premium-print-yearly-dynamic-count',
    payment_gateway: ['bank_transfer'],
    type: 'business',
  },
  {
    id: 15,
    code: 'family-print-yearly-dynamic-count',
    payment_gateway: ['gopay', 'gopay_recurrent'],
    type: 'business',
  },
  {
    id: 16,
    code: 'family-print-yearly-dynamic-count',
    payment_gateway: ['bank_transfer'],
    type: 'business',
  },
  {
    id: 17,
    code: 'family-premium-yearly-dynamic-count',
    payment_gateway: ['gopay', 'gopay_recurrent'],
    type: 'business',
  },
  {
    id: 18,
    code: 'family-premium-yearly-dynamic-count',
    payment_gateway: ['bank_transfer'],
    type: 'business',
  },
  // SK -----------------------------
  // FOR ME -------------
  // 1 year ------
  {
    id: 19,
    code: 'R1D2022',
    payment_gateway: ['gopay', 'gopay_recurrent'],
    type: 'for-me',
  },
  {
    id: 20,
    code: 'R1D2022',
    payment_gateway: ['bank_transfer'],
    type: 'for-me',
  },
  // 2 years -----
  {
    id: 21,
    code: 'R2D2022',
    payment_gateway: ['gopay', 'gopay_recurrent'],
    type: 'for-me',
  },
  {
    id: 22,
    code: 'R2D2022',
    payment_gateway: ['bank_transfer'],
    type: 'for-me',
  },
  // GIFTS -------------
  // 1 year ------
  {
    id: 23,
    code: 'R1D2022',
    payment_gateway: ['gopay', 'gopay_recurrent'],
    type: 'gift',
  },
  {
    id: 24,
    code: 'R1D2022',
    payment_gateway: ['bank_transfer'],
    type: 'gift',
  },
  // 2 years ------
  {
    id: 25,
    code: 'R2D2022',
    payment_gateway: ['gopay', 'gopay_recurrent'],
    type: 'gift',
  },
  {
    id: 26,
    code: 'R2D2022',
    payment_gateway: ['bank_transfer'],
    type: 'gift',
  },
  // BUSINESS -------------
  // 1 year ------
  {
    id: 27,
    code: 'R1D2024-business',
    payment_gateway: ['gopay', 'gopay_recurrent'],
    type: 'business',
  },
  {
    id: 28,
    code: 'R1D2024-business',
    payment_gateway: ['bank_transfer'],
    type: 'business',
  },
  // 2 years ------
  {
    id: 29,
    code: 'R2D2024-business',
    payment_gateway: ['gopay', 'gopay_recurrent'],
    type: 'business',
  },
  {
    id: 30,
    code: 'R2D2024-business',
    payment_gateway: ['bank_transfer'],
    type: 'business',
  },
  // E-shop -----------------------------
  {
    id: 31,
    code: '', // todo after backend adjust
    payment_gateway: ['gopay', 'gopay_recurrent'],
    type: 'eshop',
  },
  {
    id: 32,
    code: '', // todo after backend adjust
    payment_gateway: ['bank_transfer'],
    type: 'eshop',
  },
  // Student -----------------------------
  // 1 year ------
  {
    id: 33,
    code: 'R1DSTUDENT2022',
    payment_gateway: ['gopay', 'gopay_recurrent'],
    type: 'student',
  },
  {
    id: 34,
    code: 'R1DSTUDENT2022',
    payment_gateway: ['bank_transfer'],
    type: 'student',
  },
  // 2 years ------
  {
    id: 35,
    code: 'R2DSTUDENT2024',
    payment_gateway: ['gopay', 'gopay_recurrent'],
    type: 'student',
  },
  {
    id: 36,
    code: 'R2DSTUDENT2024',
    payment_gateway: ['bank_transfer'],
    type: 'student',
  },
  {
    id: 37,
    code: 'premium roční',
    payment_gateway: ['bank_transfer'],
    type: 'for-me',
  },
  {
    id: 38,
    code: 'premium roční',
    payment_gateway: ['gopay', 'gopay_recurrent'],
    type: 'for-me',
  },
];
